import initialStateTemplate from './initial-state';
import { createReducer } from './reducer-creator';

function setPromotions(initialState, action) {
  return {
    ...initialState,
    promociones: action.payload,
  };
}

export default createReducer(initialStateTemplate.promociones, {
  MOSTRAR_PROMOCIONES: setPromotions,
});
